import React from 'react'
import { Helmet } from 'react-helmet'
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { withTranslation } from 'react-i18next'

interface Props {
  sitecoreContext: {
    language: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    route: any
    pageEditing: boolean
    'Discovery.Foundation.Seo.CanonicalUrl': string
  }
}

const OpenGraphMetaTags: React.FC<Props> = (props) => {
  const {
    sitecoreContext,
    sitecoreContext: { route },
  } = props
  const ogItemUrl = sitecoreContext['Discovery.Foundation.Seo.CanonicalUrl']
  const language = sitecoreContext.language

  return (
    <Helmet>
      <meta property="og:title" content={route?.fields['Open Graph Title']?.value} />
      <meta property="og:description" content={route?.fields['Open Graph Description']?.value} />
      <meta property="og:image" content={route?.fields['Open Graph Image']?.value?.src} />
      <meta property="og:url" content={ogItemUrl} />
      <meta property="og:locale" content={language} />
      <meta property="og:type" content={route?.fields['Open Graph Type']?.value} />
    </Helmet>
  )
}

export default withSitecoreContext()(withTranslation()(OpenGraphMetaTags as React.FC) as React.FC)
